import React from 'react';
import { string } from 'prop-types';
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { testidFactory } from "../../../utils/testid";
var testid = testidFactory('avatar');
export var Component = function Component(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      image = _ref.image;
  return React.createElement("div", {
    className: "avatar",
    "data-testid": testid()
  }, !!image ? React.createElement(ResponsiveImage, {
    "data-testid": testid('image'),
    imageUrl: image,
    isCircular: true
  }) : React.createElement("p", {
    "data-testid": testid('text')
  }, "".concat(firstName[0]).concat(lastName[0]).toUpperCase()));
};
Component.displayName = 'Avatar';
Component.defaultProps = {
  firstName: ' ',
  lastName: ' ',
  image: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  firstName: string,
  image: string,
  lastName: string
} : {};